// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import { CityTable } from './CityTable';
// import Row from 'react-bootstrap/esm/Row';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetCitiesData } from '../../Redux/Actions/CityAction';
// import Table from 'react-bootstrap/esm/Table';
// import CopyToClipboard from 'react-copy-to-clipboard';
// import { Alert, Snackbar, useMediaQuery } from '@mui/material';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import { Col, Spinner } from 'react-bootstrap';
// import moment from 'moment';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { Link } from 'react-router-dom';
// import { useTheme } from '@mui/material/styles';
// import AddIcon from '@mui/icons-material/Add';
// import { ChannelActions } from '../Channel/ChannelActions';

// export const AllCitiesShow = () => {
//   const [userlogin, setuserlogin] = useState('');
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li
//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//   //clipboard copy channal id
//   const [open, setOpen] = useState(false);
//   const handleCopy = () => {
//     setOpen(true); // عرض رسالة تأكيد عند النسخ
//     setTimeout(() => setOpen(false), 2000); // إخفاء الرسالة بعد 2 ثانية
//   };

//   const dispatch = useDispatch();
//   //get all cities data

//   const getallcities = async () => {
//     setLoading(true); // قبل ما تبدأ التحميل
//     await dispatch(GetCitiesData());
//     setLoading(false); // قبل ما تبدأ التحميل
//   };
//   useEffect(() => {
//     getallcities();
//   }, []);

//   const resAllCities = useSelector((state) => state.AllCities.city);

//   // let allcity=[]
//   // if(resAllCities&&resAllCities.data)
//   // {
//   //   allcity=resAllCities.data
//   // }
//   // else
//   // {
//   //   allcity=[]
//   // }

//   let allcity = Array.isArray(resAllCities?.data) ? resAllCities.data : [];

//   const [columns, setColumns] = useState([
//     { key: 'copyId', label: 'Copy Id', visible: true, width: 150 },
//     { key: 'name', label: 'City Name', visible: true, width: 150 },
//     { key: 'createdAt', label: 'Creation Date', visible: true, width: 180 },
//     { key: 'actions', label: '', visible: true, width: 120 },
//   ]);

//   const startResizing = (e, colIndex) => {
//     e.preventDefault();
//     const startX = e.clientX;
//     const startWidth = columns[colIndex].width;

//     const onMouseMove = (e) => {
//       const newWidth = Math.max(startWidth + e.clientX - startX, 50); // عرض أقل 50px
//       setColumns((prevCols) => {
//         const newCols = [...prevCols];
//         newCols[colIndex] = { ...newCols[colIndex], width: newWidth };
//         return newCols;
//       });
//     };

//     const onMouseUp = () => {
//       document.removeEventListener('mousemove', onMouseMove);
//       document.removeEventListener('mouseup', onMouseUp);
//     };

//     document.addEventListener('mousemove', onMouseMove);
//     document.addEventListener('mouseup', onMouseUp);
//   };

//   const [draggedColIndex, setDraggedColIndex] = useState(null);

//   const onDragStart = (e, index) => {
//     setDraggedColIndex(index);
//     e.dataTransfer.effectAllowed = 'move';
//   };

//   const onDragOver = (e) => {
//     e.preventDefault(); // مهم عشان يسمح بالإفلات
//   };

//   const onDrop = (e, dropIndex) => {
//     e.preventDefault();
//     if (draggedColIndex === null || draggedColIndex === dropIndex) return;

//     setColumns((prevCols) => {
//       const newCols = [...prevCols];
//       // نخرج العمود المسحوب
//       const [draggedCol] = newCols.splice(draggedColIndex, 1);
//       // ندرجه في الموقع الجديد
//       newCols.splice(dropIndex, 0, draggedCol);
//       return newCols;
//     });

//     setDraggedColIndex(null);
//   };

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           {/* <div className=' d-flex  w-100' >
//             <div className='mx-4 '>All Cities</div>
//             <a style={{textDecoration:'none'}} href='/AddCity' className='goback'>{"<<"} Go Back </a>
//         </div> */}

//           <Link
//             to={
//               userlogin?.data?.role === 'Admin'
//                 ? '/AllLeadsForAdmin'
//                 : userlogin?.data?.role === 'Marketer'
//                   ? '/ALLLeadsForMarketer'
//                   : userlogin?.data?.role === 'Accountant'
//                     ? '/LeadsForAccountant'
//                     : '/Dashboard'
//             }
//             style={{ textDecoration: 'none', color: '#102dff' }}
//           >
//             <span style={{ fontWeight: 'bold' }}>Home</span>
//           </Link>

//           <KeyboardDoubleArrowRightIcon />

//           <span style={{ color: '#666' }}>All Cities</span>

//           <div className="w-100 d-flex justify-content-end">
//             <Link to={`/AddCity`}>
//               <div
//                 className="public-color btn btn-success icon-plus addnewclientbtn  my-2"
//                 style={{ background: '#102dff' }}
//               >
//                 <AddIcon /> Add New City
//               </div>
//             </Link>
//           </div>

//           {/* <div className='d-flex w-100 '>
//                     <Link to={`/AddCity`} className='w-100'>
//                     <div className='public-color btn btn-success icon-plus addnewclientbtn  my-2' style={{background:'#0F7687'}} ><AddIcon/> Add New City</div>
//                     </Link>
//                     </div> */}
//           {/* //table */}

//           <div style={{ marginBottom: '10px' }}>
//             {columns.map((col, index) => (
//               <label key={col.key} style={{ marginRight: '10px' }}>
//                 <input
//                   type="checkbox"
//                   checked={col.visible}
//                   style={{ color: '#102dff' }}
//                   onChange={() => {
//                     const newCols = [...columns];
//                     newCols[index].visible = !newCols[index].visible;
//                     setColumns(newCols);
//                   }}
//                 />
//                 {col.label}
//               </label>
//             ))}
//           </div>

//           {!allcity || loading ? (
//             <div className="text-center py-5">
//               <Spinner animation="border" variant="" style={{ color: '#102dff' }} role="status" />
//               <div className="mt-2 text-muted">Loading data...</div>
//             </div>
//           ) : (
//             <div
//               style={{
//                 overflowX: 'auto',
//                 width: '100%',
//                 marginTop: '20px',
//                 borderRadius: '15px',
//                 //  boxShadow: mode === "dark"
//                 //    ? '0 4px 20px rgba(144, 202, 249, 0.15)'
//                 //    : '0 4px 20px rgba(15, 118, 135, 0.15)'
//               }}
//             >
//               <Table
//                 size="sm"
//                 responsive
//                 style={{
//                   minWidth: isExtraSmallScreen ? '800px' : '100%',
//                   textAlign: 'center',
//                   color: mode === 'dark' ? '#90caf9' : '#666',
//                   backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                   borderCollapse: 'separate',
//                   borderSpacing: '0',
//                   borderRadius: '15px',
//                   overflow: 'hidden',
//                 }}
//                 // className={` ${mode === 'dark' ? 'table-dark' : 'table-light'}`}
//               >
//                 <thead>
//                   <tr>
//                     {columns
//                       .filter((col) => col.visible)
//                       .map((col, index) => (
//                         <th
//                           key={col.key}
//                           draggable
//                           onDragStart={(e) => onDragStart(e, index)}
//                           onDragOver={onDragOver}
//                           onDrop={(e) => onDrop(e, index)}
//                           style={{
//                             position: 'relative',
//                             color: '#666',
//                             minWidth: `${col.width}px`,
//                             maxWidth: `${col.width}px`,
//                             whiteSpace: 'nowrap',
//                             cursor: 'grab',
//                             userSelect: 'none',
//                             borderBottom: mode === 'dark' ? '1px solid #90caf9' : '1px solid #666',
//                           }}
//                         >
//                           {col.label}
//                           <div
//                             onMouseDown={(e) => startResizing(e, index)}
//                             style={{
//                               position: 'absolute',
//                               right: 0,
//                               top: 0,
//                               height: '100%',
//                               width: '5px',
//                               cursor: 'col-resize',
//                               userSelect: 'none',
//                             }}
//                           />
//                         </th>
//                       ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td colSpan={columns.filter((c) => c.visible).length}>Loading...</td>
//                     </tr>
//                   ) : allcity?.length ? (
//                     allcity.map((item, idx) => (
//                       <tr key={idx}>
//                         {columns
//                           .filter((col) => col.visible)
//                           .map((col) => {
//                             switch (col.key) {
//                               case 'copyId':
//                                 return (
//                                   <td key={col.key}>
//                                     <CopyToClipboard onCopy={handleCopy} text={item._id}>
//                                       <div>
//                                         <ContentCopyIcon style={{ color: '#102dff' }} />
//                                       </div>
//                                     </CopyToClipboard>
//                                     <Snackbar open={open} autoHideDuration={2000}>
//                                       <Alert severity="success">Copy Done</Alert>
//                                     </Snackbar>
//                                   </td>
//                                 );
//                               case 'name':
//                                 return (
//                                   <td key={col.key} style={{ color: '#666' }}>
//                                     {item?.name}
//                                   </td>
//                                 );
//                               case 'createdAt':
//                                 return (
//                                   <td key={col.key} style={{ color: '#666' }}>
//                                     {item?.createdAt
//                                       ? moment(item?.createdAt).format('DD/MM/YYYY h:mm A')
//                                       : null}
//                                   </td>
//                                 );
//                               case 'actions':
//                                 return (
//                                   <td key={col.key}>
//                                     <CityTable city={item} allcities={getallcities} />
//                                   </td>
//                                 );
//                               default:
//                                 return null;
//                             }
//                           })}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={columns.filter((c) => c.visible).length}
//                         style={{ textAlign: 'center', color: 'gray' }}
//                       >
//                         No Data Found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </Table>
//             </div>
//           )}
//         </Col>
//       </Row>
//     </Container>
//   );
// };



























// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import { GetCitiesData } from '../../Redux/Actions/CityAction';
import { CityTable } from './CityTable';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';
// import './AllProjects.css'; // نفس الـ CSS

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconFilter = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IconCopy   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconPlus   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconCity   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9.5L12 3l9 6.5V21H3V9.5z"/><rect x="9" y="14" width="6" height="7" rx="1"/></svg>;
const IconGlobe  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>;
const IconTrend  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;

/* ─── Component ──────────────────────────────────────────────────────────── */
const EXPANDED_WIDTH = 242;

export const AllCitiesShow = () => {
  const dispatch = useDispatch();
  const theme    = useTheme();
  const mode     = theme.palette.mode;

  const [loading,      setLoading]      = useState(true);
  const [searchTerm,   setSearchTerm]   = useState('');
  const [dateFilter,   setDateFilter]   = useState('all');
  const [showFilter,   setShowFilter]   = useState(false);
  const [page,         setPage]         = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [copyOpen,     setCopyOpen]     = useState(false);
  const [userlogin,    setUserlogin]    = useState(null);
  // const [sidebarWidth, setSidebarWidth] = useState(EXPANDED_WIDTH);
  const sidebarWidth = useSidebarWidth();

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  // useEffect(() => {
  //   const h = (e) => setSidebarWidth(e.detail?.width ?? EXPANDED_WIDTH);
  //   window.addEventListener('sidebarResized', h);
  //   return () => window.removeEventListener('sidebarResized', h);
  // }, []);

  const fetchCities = async () => {
    setLoading(true);
    await dispatch(GetCitiesData());
    setLoading(false);
  };
  useEffect(() => { fetchCities(); }, []);

  const resAllCities = useSelector((s) => s.AllCities.city);
  const allcity      = Array.isArray(resAllCities?.data) ? resAllCities.data : [];

  const filtered = allcity.filter((c) => {
    const q = searchTerm.toLowerCase();
    const matchSearch = !q || c.name?.toLowerCase().includes(q);
    let matchDate = true;
    if (dateFilter !== 'all') {
      const created = moment(c.createdAt);
      const now     = moment();
      if (dateFilter === 'today') matchDate = created.isSame(now, 'day');
      if (dateFilter === 'week')  matchDate = created.isAfter(now.clone().subtract(7,  'days'));
      if (dateFilter === 'month') matchDate = created.isAfter(now.clone().subtract(30, 'days'));
    }
    return matchSearch && matchDate;
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const pageItems  = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const thisMonth  = allcity.filter(c => moment(c.createdAt).isAfter(moment().subtract(30,'days'))).length;
  const newestCity = allcity.length
    ? allcity.reduce((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? a : b)
    : null;

  const homeLink = userlogin?.data?.role === 'Admin'      ? '/AllLeadsForAdmin'
                 : userlogin?.data?.role === 'Marketer'   ? '/ALLLeadsForMarketer'
                 : userlogin?.data?.role === 'Accountant' ? '/LeadsForAccountant'
                 : '/Dashboard';

  const buildPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    if (page <= 4) {
      pages.push(1, 2, 3, 4, 5, '...', totalPages);
    } else if (page >= totalPages - 3) {
      pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
    }
    return pages;
  };

  return (
    <>
      {/*
        ✅ الـ TRICK:
        - ap-shell هو الـ scroll container (overflow-y: auto, height: calc(100vh - 50px))
        - ap-table-section فيه display:flex flex-direction:column
        - ap-table-wrap يأخذ flex:1 ويعمل scroll داخلي لو الداتا كتير
        - ap-pagination بـ position: sticky; bottom: 0
        => النتيجة: الـ pagination ثابت في أسفل الجدول دايماً ومش بيطلع برا حدوده
      */}

      <div
        className={`ap-shell ${mode}`}
        style={{
          marginLeft: sidebarWidth,
          transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
          /* ✅ الـ shell هو الـ scroll container */
          height: 'calc(100vh - 50px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          marginTop: '50px',
        }}
      >

        {/* ─── Breadcrumbs ─── */}
        <section style={{ padding: '20px 28px 0', marginBottom: '-8px', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
            <Link
              to={homeLink}
              style={{ textDecoration: 'none', color: mode === 'dark' ? '#9ca3af' : '#6b7280', fontWeight: 500, fontFamily: "'DM Sans', sans-serif" }}
            >
              Home
            </Link>
            <span style={{ color: mode === 'dark' ? '#4b5563' : '#d1d5db' }}>/</span>
            <span style={{ color: mode === 'dark' ? '#e5e7eb' : '#111827', fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
              Cities
            </span>
          </div>
        </section>

        {/* ─── Stats ─── */}
        <section className="ap-stats" style={{ padding: '24px 28px 0', flexShrink: 0 }}>
          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">TOTAL CITIES</div>
              <div className="ap-stat-value">{allcity.length}</div>
              <div className="ap-stat-badge green">↑ Active in system</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconCity /></div>
          </div>

          <div className="ap-stat-card light">
            <div>
              <div className="ap-stat-label">ADDED THIS MONTH</div>
              <div className="ap-stat-value large">{thisMonth}</div>
              <div className="ap-stat-badge green">Last 30 days</div>
            </div>
            <div className="ap-stat-icon light-icon"><IconGlobe /></div>
          </div>

          <div className="ap-stat-card dark-card">
            <div>
              <div className="ap-stat-label white">LATEST CITY</div>
              <div className="ap-stat-value white" style={{ fontSize: 20, marginTop: 4 }}>
                {newestCity?.name || '—'}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                <span className="ap-badge-pill">MOST RECENT</span>
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>
                  {newestCity ? moment(newestCity.createdAt).format('MMM DD, YYYY') : ''}
                </span>
              </div>
            </div>
            <div className="ap-stat-icon dark-icon"><IconTrend /></div>
          </div>
        </section>

        {/* ─── Table Section ─── */}
        {/*
          ✅ flex: 1 عشان يملأ باقي الارتفاع
          display: flex; flex-direction: column عشان الـ sticky يشتغل
          overflow: hidden عشان الـ border-radius يتطبق صح
        */}
        <section
          className="ap-table-section"
          style={{
            margin: '24px 28px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',          /* ✅ مهم للـ border-radius */
            minHeight: 0,                /* ✅ مهم عشان flex يشتغل صح */
          }}
        >

          {/* Table header — ثابت */}
          <div className="ap-table-header" style={{ flexShrink: 0 }}>
            <div>
              <div className="ap-table-title-label">LOCATION</div>
              <div className="ap-table-title">CITIES</div>
            </div>
            <div className="ap-table-actions">
              <div className="ap-search-inline">
                <IconSearch />
                <input
                  placeholder="Search cities by name…"
                  value={searchTerm}
                  onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
                />
              </div>
              <button className="ap-filter-btn" onClick={() => setShowFilter(!showFilter)}>
                <IconFilter /> Filter
              </button>
              <Link to="/AddCity" style={{ textDecoration: 'none' }}>
                <button className="ap-create-btn"><IconPlus /> Add New City</button>
              </Link>
            </div>
          </div>

          {/* Filter row */}
          {showFilter && (
            <div className="ap-filter-row" style={{ flexShrink: 0 }}>
              <select value={dateFilter} onChange={(e) => { setDateFilter(e.target.value); setPage(1); }}>
                <option value="all">All Dates</option>
                <option value="today">Today</option>
                <option value="week">Last 7 Days</option>
                <option value="month">Last 30 Days</option>
              </select>
              <button className="ap-clear-btn" onClick={() => { setDateFilter('all'); setSearchTerm(''); }}>Clear</button>
            </div>
          )}

          {/* ✅ Table wrap — يأخذ كل المساحة المتبقية ويعمل scroll داخلي */}
          <div className="ap-table-wrap" style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }}>
            <table className="ap-table">
              <thead>
                <tr>
                  <th style={{ width: 40, position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>
                    <input type="checkbox" className="ap-checkbox" />
                  </th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>CITY NAME</th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>CREATED DATE</th>
                  <th style={{ position: 'sticky', top: 0, zIndex: 2, background: mode === 'dark' ? '#1a1a2e' : '#fff' }}>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={4} className="ap-empty">
                      <div className="ap-spinner" />
                      <span>Loading cities…</span>
                    </td>
                  </tr>
                ) : pageItems.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="ap-empty">
                      <IconSearch />
                      <p>No cities found</p>
                    </td>
                  </tr>
                ) : (
                  pageItems.map((city, i) => (
                    <tr key={city._id || i} className="ap-row">
                      <td><input type="checkbox" className="ap-checkbox" /></td>
                      <td>
                        <div className="ap-project-cell">
                          <div className="ap-project-thumb">
                            {city.name?.slice(0, 2).toUpperCase() || 'CT'}
                          </div>
                          <span className="ap-project-name">{city.name || '—'}</span>
                        </div>
                      </td>
                      <td className="ap-cell-muted" style={{ fontSize: 13 }}>
                        {city.createdAt ? moment(city.createdAt).format('MMM DD, YYYY') : '—'}
                      </td>
                      <td>
                        <div className="ap-actions">
                          <CopyToClipboard
                            text={city._id}
                            onCopy={() => { setCopyOpen(true); setTimeout(() => setCopyOpen(false), 2000); }}
                          >
                            <button className="ap-action-btn" title="Copy ID"><IconCopy /></button>
                          </CopyToClipboard>
                          <CityTable city={city} allcities={fetchCities} />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ✅ PAGINATION — sticky في أسفل الـ table section
              بيفضل ثابت في الأسفل وأنت بتعمل scroll في الـ table
              ومش بيطلع برا حدود الجدول خالص */}
          {filtered.length > 0 && (
            <div
              className="ap-pagination"
              style={{
                position: 'sticky',
                bottom: 0,
                zIndex: 5,
                flexShrink: 0,
                backgroundColor: mode === 'dark' ? '#1a1a2e' : '#E8EAF0',
                borderTop: `1px solid ${mode === 'dark' ? '#2a2a45' : '#e8eaf0'}`,
                boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
                width: `calc(100% - 50%)`, /* 28px padding on each side */
                // margin: '0 28px',
                borderBottomLeftRadius: 8,
                borderBottomRightRadius: 8,
              }}
            >
              {/* Items per page */}
              <div className="ap-pagination-info">
                <span>Items per page:</span>
                <select
                  className="ap-page-select"
                  value={itemsPerPage}
                  onChange={(e) => { setItemsPerPage(Number(e.target.value)); setPage(1); }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span>
                  Showing{' '}
                  <strong>{(page - 1) * itemsPerPage + 1}–{Math.min(page * itemsPerPage, filtered.length)}</strong>
                  {' '}of{' '}
                  <strong>{filtered.length}</strong> cities
                </span>
              </div>

              {/* Page buttons */}
              <div className="ap-pagination-btns">
                <button className="ap-pag-btn" onClick={() => setPage(1)} disabled={page === 1}>⟨|</button>
                <button className="ap-pag-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>‹</button>

                {buildPageNumbers().map((n, idx) =>
                  n === '...'
                    ? <span key={`e-${idx}`} className="ap-pag-ellipsis">…</span>
                    : <button
                        key={n}
                        className={`ap-pag-btn ${page === n ? 'active' : ''}`}
                        onClick={() => setPage(n)}
                      >{n}</button>
                )}

                <button className="ap-pag-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>›</button>
                <button className="ap-pag-btn" onClick={() => setPage(totalPages)} disabled={page === totalPages}>|⟩</button>
              </div>
            </div>
          )}
        </section>

        {/* Footer */}
        <footer className="ap-footer" style={{ padding: '16px 28px', marginTop: 'auto', flexShrink: 0 }}>
          <span>© 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
        </footer>

      </div>

      <Snackbar open={copyOpen} autoHideDuration={2000}>
        <Alert severity="success" sx={{ width: '100%' }}>Copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};
